import { ICurrencyList } from "../types/salaryRange";

export const unFormatNumberString = (value: string, sign?: string) => {
  return value.replace(new RegExp(`[${sign},+]`, "g"), "").trim();
};

export const formatNumberString = ({
  numStr,
  sign,
  isIndianCurrency,
  isMin,
}: {
  numStr: string;
  sign?: string;
  isIndianCurrency: boolean;
  isMin?: boolean;
}): string => {
  let formattedValue = (numStr.match(/\d+(\.\d+)?/g) || []).join(""); // extracting only numbers

  const locale = isIndianCurrency ? "en-In" : "en-US";
  const isOneCr = formattedValue === "10000000";

  if (formattedValue) {
    // allow max 1 cr for indian currency
    // allow max 9,999,999 (7 digits) for non-indian currency

    if (isIndianCurrency && +formattedValue > 10000000) {
      formattedValue = new Intl.NumberFormat(locale).format(
        Number(formattedValue?.slice(0, -1))
      );
    } else if (!isIndianCurrency) {
      formattedValue = new Intl.NumberFormat(locale).format(
        Number(formattedValue?.slice(0, 7))
      );
    } else {
      formattedValue = new Intl.NumberFormat(locale).format(
        Number(formattedValue)
      );
    }
  }

  if (isIndianCurrency && numStr?.includes("+") && isOneCr && !isMin) {
    // adding + for 1cr+ salary
    formattedValue += "+";
  }

  return `${formattedValue && sign ? sign : ""} ${formattedValue}`.trim();
};

export const generateSalaryRange = (payload?: {
  startValue?: number;
  endValue?: number;
  isIndianCurrency?: boolean;
}) => {
  const start = payload?.startValue || 0;
  const end = payload?.endValue || 10000000;
  const range: { label: string; value: string }[] = [];

  let i = start;
  while (i <= end) {
    const val = formatNumberString({
      numStr: i.toString(),
      isIndianCurrency: !!payload?.isIndianCurrency,
    });
    range.push({
      label: val,
      value: val,
    });

    if (i < 1000000) {
      i += 50000; // increment by 50,000 up to 10,00,000
    } else if (i < 5000000) {
      i += 100000; // increment by 1,00,000 from 10,00,000 to 50,00,000
    } else {
      i += 500000; // increment by 5,00,000 from 50,00,000 to 1,00,00,000
    }
  }

  return range;
};

export const currencies: ICurrencyList[] = [
  {
    id: "INR",
    name: "Indian Rupees",
    sign: "₹",
    code: "in",
  },
  {
    id: "BHD",
    name: "Bahraini Dinars",
    sign: ".د.ب",
    code: "bh",
  },
  {
    id: "AED",
    name: "Dirhams",
    sign: "د.إ",
    code: "ae",
  },
  {
    id: "HKD",
    name: "Hong Kong Dollar",
    sign: "$",
    code: "hk",
  },
  {
    id: "IDR",
    name: "Indonesian Rupiah",
    sign: "Rp",
    code: "id",
  },
  {
    id: "JOD",
    name: "Jordanian Dinars",
    sign: "JD",
    code: "jo",
  },
  {
    id: "KWD",
    name: "Kuwaiti Dinars",
    sign: "د.ك",
    code: "kw",
  },
  {
    id: "LBP",
    name: "Lebanese Pounds",
    sign: "LL",
    code: "lb",
  },
  {
    id: "OMR",
    name: "Omani Riyals",
    sign: "ر.ع.",
    code: "om",
  },
  {
    id: "MOP",
    name: "Pataca",
    sign: "MOP$",
    code: "mo",
  },
  {
    id: "PHP",
    name: "Philippine Peso",
    sign: "₱",
    code: "ph",
  },
  {
    id: "QAR",
    name: "Qatari Riyals",
    sign: "ر.ق",
    code: "qa",
  },
  {
    id: "MYR",
    name: "Malaysian Ringgit",
    sign: "RM",
    code: "my",
  },
  {
    id: "SAR",
    name: "Saudi Riyals",
    sign: "ر.س",
    code: "sa",
  },
  {
    id: "SGD",
    name: "Singapore Dollar",
    sign: "$",
    code: "sg",
  },
  {
    id: "TWD",
    name: "Taiwan Dollar",
    sign: "$",
    code: "tw",
  },
  {
    id: "THB",
    name: "Thai Baht",
    sign: "฿",
    code: "th",
  },
  {
    id: "USD",
    name: "US Dollar",
    sign: "$",
    code: "us",
  },
  {
    id: "VND",
    name: "Vietnamese Dong",
    sign: "₫",
    code: "vn",
  },
  {
    id: "CNY",
    name: "Yuan Renminbi",
    sign: "¥",
    code: "cn",
  },
];
export const debounce = (callback: Function, delay: number) => {
  let timer: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};



export const getCurrencyBySiteContext = (siteContext: string) => {
  switch (siteContext) {
    case 'rexmonster':
      return 'INR';
    case 'monstergulf':
      return 'USD';
    case 'monstersingapore':
      return 'SGD';
    case 'monsterthailand':
      return 'THB';
    case 'monsterphilippines':
      return 'PHP';
    case 'monstervietnam':
      return 'VND';
    case 'monstermalaysia':
      return 'MYR';
    case 'monsterindonesia':
      return 'IDR';
    case 'monsterhongkong':
      return 'HKD';
    default:
      break;
  }
}

export function getUserDetails() {
  // Check if user details exist in session storage
  const userDetailsString = sessionStorage.getItem("userDetails");
 
  if (userDetailsString) {
    // If user details exist, parse the JSON string and return the object
    return JSON.parse(userDetailsString);
  } else {
    // If user details do not exist, return userDetails;
    return null;
  }
}
